__webpack_require__.p = "/poslovni-softver/";